import { render } from "./xjllb.vue?vue&type=template&id=0c056fd2&scoped=true&ts=true"
import script from "./xjllb.vue?vue&type=script&lang=ts"
export * from "./xjllb.vue?vue&type=script&lang=ts"

import "./xjllb.vue?vue&type=style&index=0&id=0c056fd2&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c056fd2"]])

export default __exports__